import React from "react";
import JSONPretty from "react-json-pretty";

interface JsonViewerProps {
	// json to render
	json: object;
	// display font size
	fontSize?: number;
}

/**
 * Pre-configured wrapper around JSONPretty library
 * @param props
 */
export const JsonViewer = (props: JsonViewerProps) => {
	return (
		<JSONPretty
			mainStyle={`line-height:1.5;font-size:${props.fontSize || 12}px;white-space:pre-wrap;overflow-wrap:break-word`}
			keyStyle="color:#002b36"
			stringStyle="color:#cb4b16"
			valueStyle="color:#859900"
			booleanStyle="color:#2aa198"
			data={props.json}
		/>
	);
};
